import permissions from './components/permission/reducer'
import usergroups from './components/usergroup/reducer'

const authentication = { permissions, usergroups }
export {
  authentication
}
